<template>
  <!--
    A segmented choice (PrimeVue SelectButton). An option can carry a tone,
    and the chosen option then shows it: ok green, warn gold, orange, alert
    red. Without a tone the chosen option is raised and neutral.
  -->
  <SelectButton
    v-model="model"
    :options="options"
    option-label="label"
    option-value="value"
    option-disabled="disabled"
    :allow-empty="false"
    :disabled="disabled"
    :invalid="invalid"
    :fluid="fluid"
    :size="size"
    :aria-labelledby="ariaLabelledby"
    class="kb-choice"
    :data-tone="tone"
    @change="$emit('change', $event.value)"
  />
</template>

<script setup lang="ts" generic="T extends string | number | boolean">
import { computed } from 'vue'

export interface KbChoiceOption<V> {
  label: string
  value: V
  tone?: 'ok' | 'warn' | 'orange' | 'alert'
  disabled?: boolean
}

const props = withDefaults(defineProps<{
  options: KbChoiceOption<T>[]
  disabled?: boolean
  invalid?: boolean
  fluid?: boolean
  size?: 'small' | 'large'
  ariaLabelledby?: string
}>(), { size: 'small', fluid: false })

defineEmits<{ change: [value: T] }>()

const model = defineModel<T | null | undefined>()

const tone = computed(() => props.options.find(o => o.value === model.value)?.tone)
</script>
